import type { Span } from '@ms-cloudpack/telemetry';
import type { CommandActionParams } from '../../../types/CommandAction.js';
import type { InitSummaryData } from '../InitSummaryData.js';
import type { InitOptions } from './InitOptions.js';

export interface InitAppOptions extends Pick<CommandActionParams<object>, 'isMultiApp'> {
  /** CLI options */
  initOptions: InitOptions;

  /**
   * App summary object, created ahead of time so that a partial summary can be generated
   * if the process is interrupted.
   */
  summaryData: InitSummaryData;

  /** Span for the INIT_APP operation. */
  span: Span;

  /** Skip writing the generated config to disk. */
  skipWrite?: boolean;
}
